module.exports = __webpack_public_path__ + "img/feedback-status-ilustra.b0ab8f6d.png";